import { Box, Card, CardContent, Link, Typography } from "@mui/material";
import React from "react";

type Props = {
  isReplay: boolean;
  sourceGameId?: string;
};

export const Component: React.FC<Props> = ({ isReplay, sourceGameId }) => {
  // TODO - create a helper function that generates URLs
  const sourceUrl = sourceGameId ? `https://www.tfmars.com/game/${sourceGameId}` : null;

  return (
    <Box display="flex" justifyContent="center" width="100%">
      <Card sx={{ maxWidth: 520, width: "100%" }}>
        <CardContent sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          <Typography variant="h6">Replay Summary</Typography>
          {isReplay ? (
            <Typography>
              This game is a replay -
              {sourceUrl ? (
                <>
                  {" "}
                  <Link href={sourceUrl} target="_blank" rel="noopener noreferrer">
                    {"reference game"}
                  </Link>
                </>
              ) : (
                ". Reference game unavailable."
              )}
            </Typography>
          ) : (
            <Typography>This game is not a replay.</Typography>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

Component.displayName = "ReplaySummary";
